import { render, staticRenderFns } from "./couponItem.vue?vue&type=template&id=2a171f69&scoped=true&"
import script from "./couponItem.vue?vue&type=script&lang=js&"
export * from "./couponItem.vue?vue&type=script&lang=js&"
import style0 from "./couponItem.vue?vue&type=style&index=0&id=2a171f69&lang=scss&scoped=true&"
import style1 from "./couponItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a171f69",
  null
  
)

export default component.exports